import { User } from '../../types';
import { showToRoles } from '../../utils';

export const isShowDots = (row: any, user: User) => {
  if (showToRoles('admin', user) && (row.status === 'EXPIRED' || row.status === 'ACTIVE'))
    return true;

  return showToRoles('client', user) && row.status === 'ACTIVE';
};

export const getGateInStatus = (
  validTo: number | string | Date,
  status: any,
): 'ACTIVE' | 'EXPIRED' | 'COMPLETED' | 'DELETED' => {
  if (status !== 'ACTIVE') return status;
  if (new Date(validTo) < new Date()) return 'EXPIRED';
  return status;
};
